var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.useBuefyTooltip)?_c('div',{staticClass:"cursor-default",style:(_vm.noUnderline ? '' : 'border-bottom: 1px dashed #B5B5B5'),attrs:{"title":_vm.label}},[_vm._t("default")],2):_c('div',{staticClass:"b-wrap"},[(_vm.useBuefyTooltip)?_c('b-tooltip',_vm._b({class:{
            'allow-line-breaks': _vm.allowLineBreaks,
            'is-small': _vm.isSmall
        },attrs:{"type":"is-white"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._t("content")]},proxy:true}],null,true)},'b-tooltip',_vm.$props,false),[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }